import React, { useEffect, useState } from "react";
import { api, formatDateTime } from "../lib/api";
import { PageHeader, LoadingRows, EmptyState } from "../components/common";
import { Card } from "../components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";

export default function AuditLogs() {
  const [items, setItems] = useState([]); const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/audit-logs", { params: { limit: 200 } }).then((r) => { setItems(r.data.items); setLoading(false); }); }, []);
  if (loading) return <LoadingRows rows={6} />;
  return (
    <>
      <PageHeader title="Audit Logs" description="Immutable trail of every action across the platform." />
      <Card className="rounded-xl">
        {items.length === 0 ? <div className="p-6"><EmptyState title="No audit logs yet" /></div> : (
          <Table>
            <TableHeader><TableRow>
              <TableHead>When</TableHead><TableHead>User</TableHead><TableHead>Action</TableHead>
              <TableHead>Entity</TableHead><TableHead>Details</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {items.map((l) => (
                <TableRow key={l.id}>
                  <TableCell className="text-xs text-muted-foreground whitespace-nowrap">{formatDateTime(l.created_at)}</TableCell>
                  <TableCell className="text-sm">{l.user_email || "system"}</TableCell>
                  <TableCell className="text-sm capitalize font-medium">{l.action}</TableCell>
                  <TableCell className="text-sm">{l.entity}</TableCell>
                  <TableCell className="text-xs text-muted-foreground truncate max-w-md">{l.details}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Card>
    </>
  );
}
